"use client";

import { useEffect } from "react";
import { preloadCriticalImages } from "@/lib/utils/image-preloading";

export function ImagePreloader() {
  useEffect(() => {
    // Preload critical images on client-side mount
    preloadCriticalImages();
  }, []);

  return null; // This component doesn't render anything
}
